import React from "react";
import styles from "./callhistory.module.css";
import ContactRow from "./contactrow";

//좌측 카드: 필터 바(전체 / 콜백 필요 N / 오늘) + 실제 <table> (고객 | 상태 | 최근 | 댓글)
const ContactsTable : React.FC<any> = (props) => {

    const filters = [
        { key : "all", label : "전체" },
        { key : "callback", label : "콜백 필요" },
        { key : "today", label : "오늘" }
    ];

    return (
        <div className={`${styles.card} ${styles.leftCard}`}>
            <div className={styles.filterBar}>
                {
                    filters.map((f) => (
                        <div
                            key={f.key}
                            className={`${styles.filterPill} ${props.filter === f.key ? styles.filterPillActive : ""}`}
                            onClick={() => props.onFilter(f.key)}
                        >
                            {f.label}
                            {f.key === "callback" && props.callbackCount > 0 ? <span className={styles.filterCount}>{props.callbackCount}</span> : ""}
                        </div>
                    ))
                }
            </div>
            <table className={styles.table}>
                <thead>
                    <tr>
                        <th className={styles.thCustomer}>고객</th>
                        <th className={styles.thStatus}>상태</th>
                        <th className={styles.thRecent}>최근</th>
                        <th className={styles.thComment}>댓글</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        props.contacts.length === 0 ?
                            <tr className={styles.emptyRow}>
                                <td colSpan={4}>{props.loading ? "불러오는 중..." : "표시할 통화가 없습니다"}</td>
                            </tr>
                            :
                            props.contacts.map((c : any) => (
                                <ContactRow
                                    key={c.phoneNumber}
                                    contact={c}
                                    selected={c.phoneNumber === props.selectedPhone}
                                    now={props.now}
                                    onSelect={props.onSelect}
                                    onComment={props.onComment}
                                />
                            ))
                    }
                    {
                        props.total > props.contacts.length ?
                            <tr className={styles.moreRow}>
                                <td colSpan={4}>
                                    <button className={styles.moreBtn} onClick={props.onMore}>더 보기 ({props.contacts.length}/{props.total})</button>
                                </td>
                            </tr>
                            :
                            null
                    }
                </tbody>
            </table>
        </div>
    );
};

export default ContactsTable;
